module.exports = __webpack_public_path__ + "platform/static/media/chart.05db2937.png";